import { Button, Form, Input, message, Modal, Select } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { IDoctorInfo, IDoctorOrderAdd } from 'src/entity/DoctorEntity';
import { IRechargeInfo } from 'src/entity/RechargeEntity';
import DoctorService from 'src/services/DoctorService';
import I18N from 'src/services/I18NService';
import { UtilDateTime } from 'src/utils/datetime';
import { Dispatch } from 'redux';
import { fetchRechargeOptionsIfNeeded, filterRechargeOption, RechargeOptionList } from 'src/redux/actions/rechargeCreator';
import { IStateCollection } from 'src/entity/StateEntity';

const confirm = Modal.confirm;

interface IVASOrderAddComponentProps extends FormComponentProps {
  doctorInfo: IDoctorInfo;
  isDomestic: boolean;
  rechargeList: IRechargeInfo[];
  callback(): void;
  dispatch: Dispatch<IStateCollection>;
}

/**
 * 新增订单组件
 * @class OrderAddComponent
 * @extends {React.Component<IVASOrderAddComponentProps>}
 */
class VASOrderAddComponent extends React.Component<IVASOrderAddComponentProps> {
  canSubmit: boolean = true;

  constructor(props: IVASOrderAddComponentProps) {
    super(props);
  }

  async UNSAFE_componentWillMount() {
    await this.props.dispatch(fetchRechargeOptionsIfNeeded());
  }

  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const rechargeObj: IRechargeInfo = RechargeOptionList.find(r => r.value === values.recharge) as IRechargeInfo;
        if (!!rechargeObj) {
          confirm({
            title: `${I18N.get('doc_add_to_user')}${I18N.get(rechargeObj.key)}?`,
            content: I18N.get('doc_warning_undone'),
            okText: I18N.get('common_ok'),
            cancelText: I18N.get('common_cancel'),
            onOk: () => this.orderSubmit(values.recharge),
            onCancel() { },
          });
        }
      }
    });
  };

  orderSubmit = (recharge: number) => {
    if (!this.canSubmit) {
      return;
    }
    const { doctorInfo } = this.props;
    const data: IDoctorOrderAdd = {
      order_id: UtilDateTime.nowFormat('yyyyMMddhhmmssS'),
      package: String(recharge),
      institution_uuid: doctorInfo.hospital
    };
    this.canSubmit = false;
    DoctorService.agentDoctorAddOrder(data)
      .then((res) => {
        if (res?.success) {
          message.success(I18N.get('common_save_success'));
          this.canSubmit = true;
          this.props.callback();
        } else {
          message.error(res?.msg)
        }
      })
      .catch(error => {
        this.canSubmit = true;
        if (!!error.response) {
          message.error(JSON.stringify(error.response.data));
        } else {
          message.error(I18N.get('err_save_failure'));
        }
      });
  };

  render() {
    const { doctorInfo, rechargeList } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 6 },
      wrapperCol: { span: 15 },
    };

    let rechargeOptions: IRechargeInfo[] = [];
    if (!!doctorInfo && !!doctorInfo.organization) {
      rechargeOptions = filterRechargeOption(rechargeList, doctorInfo.RechargeSevenCount || 0);
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <Form.Item label={I18N.get('common_name')} {...formItemLayout}>
          {getFieldDecorator(`name`, {
            initialValue: !!doctorInfo ? `${doctorInfo.last_name}${doctorInfo.first_name}` : null,
          })(<Input disabled={true} />)}
        </Form.Item>
        <Form.Item label={I18N.get('doc_account_type')} {...formItemLayout}>
          {getFieldDecorator(`certification_level`, {
            initialValue:
              !!doctorInfo && doctorInfo.certification_level !== undefined ? DoctorService.getCertificationLevel(doctorInfo.certification_level) : '',
          })(<Input disabled={true} />)}
        </Form.Item>
        <Form.Item label={I18N.get('doc_validity_date_latest')} {...formItemLayout}>
          {getFieldDecorator('validityDate', {
            initialValue: !!doctorInfo ? doctorInfo.valid_time : null,
          })(<Input disabled={true} />)}
        </Form.Item>
        <Form.Item label={I18N.get('doc_recharge')} {...formItemLayout}>
          {getFieldDecorator(`recharge`, {
            rules: [
              {
                required: true,
                message: `${I18N.get('common_choose')}${I18N.get('doc_recharge')}`,
              },
            ],
            initialValue: 2,
          })(
            <Select placeholder={`${I18N.get('common_choose')}${I18N.get('doc_recharge')}`}>
              {rechargeOptions.map(r => {
                return (
                  <Select.Option key={r.key} value={r.value}>
                    {I18N.get(r.key)}
                  </Select.Option>
                );
              })}
            </Select>
          )}
        </Form.Item>

        <Form.Item wrapperCol={{ span: 12, offset: 6 }}>
          <Button type="primary" htmlType="submit">
            {I18N.get('common_submit')}
          </Button>
        </Form.Item>
      </Form>
    );
  }
}

const VASOrderAddForm = Form.create<IVASOrderAddComponentProps>()(VASOrderAddComponent);
export default VASOrderAddForm;



// WEBPACK FOOTER //
// ./src/components/common/VASOrderAddForm.tsx